import { forwardRef } from "react";
import "./Input.scss";

type InputProps = {
  label?: string;
  icon?: React.ReactNode;
  onIconClick?: () => void;
  isError?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, icon, onIconClick, isError, ...props },
  ref,
) {
  if (
    props.type === "checkbox" ||
    props.type === "radio" ||
    props.type === "file"
  ) {
    return <input ref={ref} {...props} />;
  }

  return (
    <div className="w-100">
      {label && <label className="input-label">{label}</label>}

      <div className="input-wrapper">
        {icon && (
          <span
            onClick={onIconClick ? onIconClick : () => {}}
            className="input-icon"
          >
            {icon}
          </span>
        )}

        <input
          ref={ref}
          className={`input-field ${icon ? "has-icon" : ""} ${isError ? "error-input-red" : ""}`}
          {...props}
        />
      </div>
    </div>
  );
});

export default Input;
